import { handleActions } from 'redux-actions';
import routeParamMappings from '../config/routeParamMappings.json';
import _ from 'lodash';

export default handleActions({
  UPDATE_ROUTE_PARAMS: (state, { payload }) => {
    // this is used for ad requests, enetpulse, etc
    let result;
    if (payload.params.sports) {
      try {
        const sportParam = decodeURIComponent(payload.params.sports);
        result = routeParamMappings[payload.country][sportParam];
      } catch (e) {
        result = 'othersports';
      }
    }

    if (_.isArray(result) ) return _.first(result);

    if (_.isObject(result)) return 'othersports';

    return result || '';
  },
}, {});



// WEBPACK FOOTER //
// ./src/reducer/mappedSportRouteParam.js